
import { Box, Container, Typography } from "@mui/material";
import { motion } from "motion/react";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import { IconButton, Stack } from '@mui/material';
import Footer from "./Footer";

const bgHome = "/img/backgroundsection1.png";
const Contacto = () => {

    return (

        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage: `url(${bgHome})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center bottom",
                    backgroundRepeat: "no-repeat",
                    transform: "rotate(180deg)",
                }}
            />

            <Box
                sx={{
                    position: "relative",
                    zIndex: 1,
                    flex: 1,
                }}
            >
                <Typography
                    sx={{
                        color: "#ffd700",
                        textAlign: 'center',
                        fontSize: {
                            xs: "2rem",
                            md: "3rem",
                        },
                        fontWeight: 300,
                        pt: '100px',
                    }}
                >
                    Contactanos
                </Typography>

                <br /> <br />
                <Typography
                    sx={{
                        color: "#4e6b4d",
                        textAlign: 'center',
                        fontSize: {
                            xs: "0.5rem",
                            md: "1rem",
                        },
                        fontWeight: 100,
                    }}
                >
                    Dirección postal
                </Typography>
                <Typography
                    sx={{
                        color: "#ffd700",
                        textAlign: 'center',
                        fontSize: {
                            xs: "1rem",
                            md: "2rem",
                        },
                        fontWeight: 300,
                    }}
                >
                    direccion ready cash
                </Typography>
                <br /> <br />

                <Typography
                    sx={{
                        color: "#4e6b4d",
                        textAlign: 'center',
                        fontSize: {
                            xs: "0.5rem",
                            md: "1rem",
                        },
                        fontWeight: 100,
                    }}
                >
                    Dirección de correo electrónico
                </Typography>
                <Typography
                    sx={{
                        color: "#ffd700",
                        textAlign: 'center',
                        fontSize: {
                            xs: "1rem",
                            md: "2rem",
                        },
                        fontWeight: 300,
                    }}
                >
                    correo@readycash.com
                </Typography>
                <br /> <br />
                <Typography
                    sx={{
                        color: "#4e6b4d",
                        textAlign: 'center',
                        fontSize: {
                            xs: "0.5rem",
                            md: "1rem",
                        },
                        fontWeight: 100,
                    }}
                >
                    Número telefónico
                </Typography>
                <Typography
                    sx={{
                        color: "#ffd700",
                        textAlign: 'center',
                        fontSize: {
                            xs: "1rem",
                            md: "2rem",
                        },
                        fontWeight: 300,
                    }}
                >
                    (686) 123 4567
                </Typography>
                <br /> <br />
                
            </Box>
            <Footer />
        </Box>

    )

}

export default Contacto